import React from "react";
import "react-calendar/dist/Calendar.css";
import "react-date-picker/dist/DatePicker.css";
import { MdCalendarMonth } from "react-icons/md";
import { check } from "../../resources/js/images";
import P from "../../shared/typography/P";
import TextField from "../../shared/ui/Form/TextField";
import Instruction from "./Instruction";

/* @TODO => Update fonts [colors, fontFamily, weight ],  @habib610 Fri March 28,2025 */
/* @TODO => Align label and input in same as figma @habib610 Fri March 28,2025 */
const FeasibilitySurvey = ({ data }) => {
    return (
        <>
            <div className="rounded-t-2.5   md:border md:shadow-md md:rounded-3xl bg-white md:bg-transparent">
                <div className="bg-white min-h-[60rem] md:min-h-full rounded-t-2.5 md:rounded-3xl w-full p-3 md:p-2">
                    <div className="flex flex-wrap sm:flex-nowrap justify-between items-center gap-1 sm:gap-5">
                        <P className="w-full sm:w-1/2">
                            Feasibility Survey Booking Date
                        </P>
                        <div
                            className={` relative px-px py-px  border  w-full sm:w-[40%]  rounded-lg border-[#DCDCDC] text-btn-s`}
                        >
                            <TextField
                                label={""}
                                disabled={true}
                                value={data?.surveyDate}
                                name={"date"}
                                wrapper={"h-[40px] w-full sm:w-auto"}
                                inputWrapper="rounded-l-md"
                                type={"text"}
                                size={"w-full "}
                                icon={
                                    <MdCalendarMonth
                                        size={25}
                                        className="text-gray-500"
                                    />
                                }
                                iconWrapperClass={
                                    " p-[1.5rem] h-[36px] bg-white rounded-r-md "
                                }
                            />
                        </div>
                    </div>
                    <div className="flex w-full flex-wrap sm:flex-nowrap justify-between items-center  gap-1 sm:gap-5 my-3">
                        <P className=" w-full sm:w-1/2">
                            {" "}
                            Feasibility Survey Perform
                        </P>
                        <TextField
                            label={""}
                            disabled={true}
                            value={data?.surveyStatus}
                            name={"surveyStatus"}
                            wrapper={"h-[40px] w-full sm:w-auto"}
                            inputWrapper="  rounded-l-md "
                            type={"text"}
                            size={"w-full sm:w-[40%]"}
                            icon={
                                data?.surveyStatus === "COMPLETED" ? (
                                    <img
                                        src={check}
                                        alt="check"
                                        className="w-4 h-2.8 md:h-2"
                                    />
                                ) : (
                                    <div className="w-2 h-2 bg-blue-300 rounded-full "></div>
                                )
                            }
                            iconWrapperClass={
                                " p-[1.5rem] h-[36px] bg-white rounded-r-md "
                            }
                        />
                    </div>
                    <ul className="ml-3">
                        <P className="flex flex-col gap-0.5 font-light">
                            <li className="list-disc">
                                Total shade free area available
                            </li>
                            <li className="list-disc">
                                Perform shadow analysis
                            </li>
                            <li className="list-disc">
                                Your recent electricity bill
                            </li>
                            <li className="list-disc">
                                Ask for your preferences and requirements
                            </li>
                        </P>
                    </ul>
                    <div className="flex flex-wrap sm:flex-nowrap justify-between items-center gap-1 sm:gap-5 my-3">
                        <P className="w-full sm:w-1/2"> Proposal Generated</P>
                        <TextField
                            label={""}
                            disabled={true}
                            value={data?.proposalStatus}
                            name={"proposalStatus"}
                            wrapper={"h-[40px]  bg-transparent"}
                            size={"w-full sm:w-[40%]"}
                            inputWrapper="  rounded-l-md "
                            type={"text"}
                            icon={
                                data?.proposalStatus === "SUCCESSFUL" ? (
                                    <img
                                        src={check}
                                        alt="check"
                                        className="w-4 h-2.8 md:h-2"
                                    />
                                ) : (
                                    <div className="w-2 h-2 bg-blue-300 rounded-full "></div>
                                )
                            }
                            iconWrapperClass={
                                " p-[1.5rem] h-[36px] bg-white rounded-r-md "
                            }
                        />
                    </div>
                </div>
            </div>

            <Instruction className="hidden md:flex " />
        </>
    );
};

export default FeasibilitySurvey;
